import * as React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { isEmpty, isNumber } from 'lodash';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';
import { fetchListInfluencers, updateScreenState } from 'modules/lists/reducers/lists';

import { COLLECTION_SORT_LIST } from 'utils/list';

import './lists-sort.scss';

import type {
  Data,
  LocationWindow,
  MixedSelectDropdownItem,
  ParamsLists
} from 'types';

type OwnProps = {
  sort: string,
  params: ParamsLists,
  location: LocationWindow,
  searchByName: string
};

type DispatchProps = {
  dispatchUpdateScreenState: (b: string | number, a: string) => void,
  dispatchFetchListsInfluencers: (c: number, b: number, a: string) => void
};

type Props = OwnProps & DispatchProps;

type State = {
  sort: string
};

class ListsSort extends React.PureComponent<Props, State> {
  state = {
    sort: this.props.sort || ''
  };

  getDropdownItems = (): Array<MixedSelectDropdownItem> => {
    const { sort } = this.state;
    const sortList = Object.keys(COLLECTION_SORT_LIST);

    return sortList.map(value => ({
      identifier: value,
      isDisabled: false,
      isSelected: sort === value,
      label: COLLECTION_SORT_LIST[value],
      value
    }));
  };

  handleSortChange = (
    updatedItems: Array<MixedSelectDropdownItem>,
    data?: Data | null,
    selectedItem?: Partial<MixedSelectDropdownItem> | null
  ): void => {
    const { params, location, searchByName, dispatchUpdateScreenState, dispatchFetchListsInfluencers } = this.props;
    const value = selectedItem?.identifier || updatedItems[0].identifier;
    const orgId = Number(location?.query?.orgId);

    this.setState({
      sort: String(value)
    });

    if (isNumber(orgId)) {
      dispatchUpdateScreenState(1, 'page');
      dispatchUpdateScreenState(String(value), 'sort');
      dispatchFetchListsInfluencers(orgId, Number(params.listId), searchByName);
    }
  };

  render(): React.ReactNode {
    const { searchByName } = this.props;
    const { sort } = this.state;
    const isSearchByName = !isEmpty(searchByName);
    const dropdownItems = this.getDropdownItems();

    const labelClasses = classnames('lists-sort__label', {
      'lists-sort__label--is-disabled': isSearchByName
    });

    return (
      <section className="lists-sort">
        <span className={labelClasses}>
          Sort by:
        </span>
        <MixedSelectDropdown
          key={`lists-sort__dropdown--${sort}`}
          name="lists-sort__dropdown"
          items={dropdownItems}
          isDisabled={isSearchByName}
          withSelectedInList
          className="lists-sort__dropdown"
          onItemsToggle={this.handleSortChange}
        />
      </section>
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchUpdateScreenState: (value, propName) => {
    dispatch(updateScreenState(value, propName));
  },

  dispatchFetchListsInfluencers: (orgId, listId, name) => {
    dispatch(fetchListInfluencers(orgId, listId, name));
  }
});

export default connect(null, mapDispatchToProps)(ListsSort);
